<template>
    <div id="attribute-form">
        <div class="input">
            <label>{{ $t("settings.label") }}</label>
            <input v-model="form.label" no-flags @input="formatName(form.label)" />
        </div>
        <div class="input">
            <label>{{ $t("coupon.name") }}</label>
            <input v-model="form.name" no-flags @input="formatName(form.name)" />
        </div>
        <div class="input">
            <label>{{ $t("message.type") }}</label>
            <a-select ref="select" v-model="form.type" autocomplete="off">
                <a-select-option v-for="type of types" :value="type.value" :key="type.value">
                    {{ type.text }}
                </a-select-option>
            </a-select>
        </div>
        <div class="input dropdown" v-if="form.type == 'dropdown'">
            <label>{{ $t("message.options") }}</label>
            <div class="form">
                <div style="display: flex; align-items: center; margin-bottom: 5px">
                    <input v-model="option" no-flags />
                    <a-button
                        type="primary"
                        style="display: flex; justify-content: center; align-items: center; margin-left: 5px"
                        @click="addOption()"
                    >
                        <span class="material-icons" style="font-size: 16px"> add </span>
                    </a-button>
                </div>
                <div class="options">
                    <a-tag
                        v-for="(option, index) of form.options"
                        :closable="true"
                        :key="index"
                        @close="removeOption(index)"
                        color="blue"
                    >
                        {{ option }}
                    </a-tag>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeatureItem from "./FeatureItem";
import log2 from "../../../../utils/log2";

const log = log2("VisitorAttributesForm");
export default {
    name: "VisitorAttributesForm",
    components: { FeatureItem },
    props: {
        initialData: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        option: null,
        form: {
            name: null,
            label: null,
            type: null,
            options: [],
            visible: true,
        },
        types: [
            { text: "Yazı", value: "text" },
            { text: "Mail", value: "email" },
            { text: "Telefon", value: "phone" },
            { text: "Sayı", value: "number" },
            { text: "URL", value: "url" },
            { text: "Tarih", value: "date" },
            { text: "Seçilebilir", value: "dropdown" },
            { text: "JSON", value: "json" },
            { text: "Temsilci", value: "agent" },
        ],
    }),
    methods: {
        addOption() {
            this.form.options = this.$_.uniq([...this.form.options, this.option]);
            this.option = null;
        },
        removeOption(index) {
            this.form.options = this.form.options.filter((o, i) => i !== index);
        },
        formatName(text) {
            this.form.name = text.toLowerCase().replace(/[^a-z0-9\.,_]/gim, "");
        },
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit("input", newVal);
            },
            deep: true,
        },
        initialData: {
            handler(newVal) {
                if (newVal) {
                    this.form = {
                        name: newVal.name || null,
                        label: newVal.label || null,
                        type: newVal.type || null,
                        options: newVal.options || [],
                        visible: newVal.visible !== undefined ? newVal.visible : true,
                    };
                }
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.dark-mode {
    .attribute-item {
        background: #1e1e2d !important;
        border: 1px solid var(--color-border-default);

        .attribute-value span {
            color: white !important;
        }
    }
}

.attribute-item {
    .ant-switch-checked {
        background-color: var(--color-bg-primary-default);
    }
}
</style>
<style lang="scss" scoped>
#attribute-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    :first-child.input {
        margin-top: 0 !important;
    }

    .input {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 5px;

        label {
            margin-bottom: 0px;
        }

        input {
            border: 1px solid var(--color-border-default);
            border-radius: 5px;
            padding: 5px 10px;
            flex: 1;
            outline: none;

            &:focus {
                border: 1px solid #1999e3;
                box-shadow: 0 0 0 2px rgba(25, 153, 227, 0.2);
            }

            &.error {
                border: 1px solid red;
                box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
            }
        }
    }
}
</style>
